module.exports = __webpack_public_path__ + "static/media/Folder.0f6c0267.png";